"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _Item = _interopRequireDefault(require("../Dropdown/Item"));

var _Input = _interopRequireDefault(require("../Input"));

var _Button = _interopRequireDefault(require("../Button"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Options = _interopRequireDefault(require("./Options"));

var _common = require("../../common");

var _lib = require("../../lib");

var _constants = require("../../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var getMomentObj = function getMomentObj(props) {
  var value = props.value,
      format = props.format;

  if (value) {
    if ((0, _moment["default"])(value, format, true).isValid()) {
      return (0, _moment["default"])(value, format);
    }
  }

  return null;
};

var resetValue = {
  hour: null,
  minute: null
};

var TimePicker =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TimePicker, _PureComponent);

  function TimePicker(props) {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimePicker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getInitMode", function (value) {
      if (value && (0, _moment["default"])(value).isValid()) {
        var currentHour = value.hour();
        if (currentHour > 12) return 'pm';
        return 'am';
      }

      return 'am';
    });

    _defineProperty(_assertThisInitialized(_this), "getRenderValue", function () {
      var _this$props = _this.props,
          format = _this$props.format,
          renderFormat = _this$props.renderFormat,
          use24Hours = _this$props.use24Hours;
      var value = _this.state.value;

      if (value && (0, _moment["default"])(value, format, true).isValid()) {
        if (use24Hours) return value.format('HH:mm');
        return value.format(renderFormat);
      }

      return '';
    });

    _defineProperty(_assertThisInitialized(_this), "hourRef", _react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "minuteRef", _react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "handleOnToggle", function (e) {
      var visible = _this.state.visible;
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          onClick = _this$props2.onClick;
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');

      if (disabled) {
        return;
      }

      if (!visible) {
        _this.handleOnOpen(e);
      } else {
        _this.handleOnClose(e);
      }

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnOpen", function (e) {
      (0, _lib.callEventMethods)(e, 'stopPropagation');

      _this.setState({
        visible: true
      }, function () {
        document.addEventListener('click', _this.handleCheckClose);

        _this.handleGetScrollTop();

        var onOpen = _this.props.onOpen;

        if (onOpen) {
          onOpen(e, _this.props);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleGetScrollTop", function () {
      var use24Hours = _this.props.use24Hours;
      var _this$state = _this.state,
          mode = _this$state.mode,
          value = _this$state.value,
          initValue = _this$state.initValue;
      var hourNode = _this.hourRef.current;
      var minuteNode = _this.minuteRef.current;

      if (value) {
        var currentHour = value.hour();
        var currentMinute = value.minute();

        if (currentHour && currentMinute) {
          if (hourNode && minuteNode) {
            // 12 hour mode
            var newCurrentHour = currentHour;

            if (mode === 'pm' && !use24Hours) {
              newCurrentHour -= 12;
            } // indexes


            var hourIndex = _constants.hour.findIndex(function (o) {
              return o.value === newCurrentHour;
            });

            if (use24Hours) hourIndex = _constants.hour24.findIndex(function (o) {
              return o.value === newCurrentHour;
            });

            var minuteIndex = _constants.minute.findIndex(function (o) {
              return o.value === currentMinute;
            }); // hour scrollTop


            if (hourIndex > -1) {
              var selectedOptionScrollTop = hourNode.children[hourIndex].offsetTop;
              hourNode.scrollTop += selectedOptionScrollTop;
            } // minute scrollTop


            if (minuteIndex > -1) {
              var _selectedOptionScrollTop = minuteNode.children[minuteIndex].offsetTop;
              minuteNode.scrollTop += _selectedOptionScrollTop;
            }
          }
        }
      } // Init scrollTop


      if (!value && initValue) {
        var _currentHour = initValue.hour;
        var _currentMinute = initValue.minute;

        if (_currentHour) {
          var _hourIndex = _constants.hour.findIndex(function (o) {
            return o.value === _currentHour;
          });

          if (use24Hours) _hourIndex = _constants.hour24.findIndex(function (o) {
            return o.value === _currentHour;
          }); // hour scrollTop

          if (_hourIndex > -1) {
            var _selectedOptionScrollTop2 = hourNode.children[_hourIndex].offsetTop;
            hourNode.scrollTop += _selectedOptionScrollTop2;
          }
        }

        if (_currentMinute) {
          var _minuteIndex = _constants.minute.findIndex(function (o) {
            return o.value === _currentMinute;
          }); // minute scrollTop


          if (_minuteIndex > -1) {
            var _selectedOptionScrollTop3 = minuteNode.children[_minuteIndex].offsetTop;
            minuteNode.scrollTop += _selectedOptionScrollTop3;
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClose", function (e) {
      (0, _lib.callEventMethods)(e, 'stopPropagation');

      _this.setState({
        visible: false
      }, function () {
        document.removeEventListener('click', _this.handleCheckClose);
        var onClose = _this.props.onClose;

        if (onClose) {
          onClose(e, _this.props);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckClose", function (e) {
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');
      var visible = _this.state.visible;

      if (visible) {
        if (!e.target.classList.contains(_Item["default"].className)) {
          // if click on dropdown item, wont close, otherwise close
          _this.handleOnClose(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCallOnChange", function (e) {
      var format = _this.props.format;
      var momentObj = _this.state.value;
      var outputValue = momentObj.format(format);

      if (format === 'unix') {
        outputValue = momentObj.unix();
      }

      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          name = _this$props3.name;

      if (onChange) {
        onChange(e, {
          name: name,
          value: outputValue
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, _ref) {
      var type = _ref.name,
          value = _ref.value;
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');
      var use24Hours = _this.props.use24Hours;
      var mode = _this.state.mode;
      var newValue = value;

      if (type === 'hour') {
        if (mode === 'pm' && !use24Hours) {
          newValue += 12;
        }
      }

      if (_this.state.value) {
        var momentObj = _this.state.value.clone(); // ex: moment().minute(10)


        momentObj[type](newValue);

        _this.setState({
          value: momentObj
        }, function () {
          _this.handleCallOnChange(e);
        });
      } else {
        // for no moment obj as value
        var initValue = _this.state.initValue;
        initValue[type] = newValue;

        _this.setState({
          initValue: initValue
        }, function () {
          if ((0, _lib.objKeysHasValue)(initValue)) {
            var _momentObj = (0, _moment["default"])({
              hour: initValue.hour,
              minute: initValue.minute
            });

            _this.setState({
              value: _momentObj,
              initValue: Object.assign({}, resetValue)
            }, function () {
              _this.handleCallOnChange(e);
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnModeChange", function (e, _ref2) {
      var value = _ref2.value;

      _this.setState({
        mode: value
      }, function () {
        if (_this.state.value) {
          var momentObj = _this.state.value.clone();

          var currentHour = momentObj.hour();

          if (value === 'am') {
            if (currentHour >= 12) {
              momentObj.set('hours', currentHour - 12);
            }
          } else if (currentHour < 12) {
            momentObj.set('hours', currentHour + 12);
          }

          _this.setState({
            value: momentObj
          }, function () {
            _this.handleCallOnChange(e);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputOnChange", function (e, _ref3) {
      var value = _ref3.value;
      var format = _this.props.format; // check if input value is a valid string format ( strict )

      if ((0, _moment["default"])(value, format, true).isValid()) {
        var momentObj = (0, _moment["default"])(value, format);

        _this.setState({
          value: momentObj
        }, function () {
          _this.handleCallOnChange(e);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isHourSelected", function (v) {
      var use24Hours = _this.props.use24Hours;
      var _this$state2 = _this.state,
          value = _this$state2.value,
          mode = _this$state2.mode,
          initValue = _this$state2.initValue;

      if (initValue && !value) {
        return initValue.hour === v;
      }

      if (value) {
        if (mode === 'pm' && !use24Hours) {
          return value.hour() === v + 12;
        }

        return value.hour() === v;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "isMinuteSelected", function (v) {
      var _this$state3 = _this.state,
          value = _this$state3.value,
          initValue = _this$state3.initValue;

      if (initValue && !value) {
        return initValue.minute === v;
      }

      if (value) {
        return value.minute() === v;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "isAMPMSelected", function (v) {
      var mode = _this.state.mode;
      return mode === v;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClear", function (e) {
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');

      _this.setState({
        value: null,
        initValue: Object.assign({}, resetValue)
      }, function () {
        var _this$props4 = _this.props,
            onChange = _this$props4.onChange,
            name = _this$props4.name;

        if (onChange) {
          onChange(e, {
            name: name,
            value: null
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [TimePicker.className];
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function (e, _ref4) {
      var value = _ref4.value;
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');
      var format = _this.state.format;
      var initValue = _this.state.initValue; // check if input value is a valid string format ( strict )

      if (!(0, _moment["default"])(value, format, true).isValid() && !initValue) {
        _this.handleOnClear(e);
      }
    });

    var _value = props.value;

    var _newValue = getMomentObj(props);

    _this.state = {
      prevProps: {
        value: _value
      },
      value: _newValue,
      visible: false,
      initValue: Object.assign({}, resetValue),
      mode: _this.getInitMode(_newValue)
    };
    return _this;
  }

  _createClass(TimePicker, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          clearable = _this$props5.clearable,
          readOnly = _this$props5.readOnly,
          onClick = _this$props5.onClick,
          onOpen = _this$props5.onOpen,
          onClose = _this$props5.onClose,
          onChange = _this$props5.onChange,
          value = _this$props5.value,
          name = _this$props5.name,
          use24Hours = _this$props5.use24Hours,
          format = _this$props5.format,
          renderFormat = _this$props5.renderFormat,
          rest = _objectWithoutProperties(_this$props5, ["clearable", "readOnly", "onClick", "onOpen", "onClose", "onChange", "value", "name", "use24Hours", "format", "renderFormat"]);

      var visible = this.state.visible;
      var classNames = this.classNames();
      var renderValue = this.getRenderValue();
      return _react["default"].createElement(_Input["default"], _extends({}, rest, {
        readOnly: readOnly,
        className: classNames,
        placeholder: "HH:MM",
        value: renderValue,
        onChange: this.handleInputOnChange,
        onClick: !readOnly ? this.handleOnToggle : null,
        onBlur: this.handleOnBlur,
        suffix: this.state.value && clearable && !readOnly ? _react["default"].createElement(_Button["default"], {
          className: "close-button",
          basic: true,
          color: "blue",
          icon: _react["default"].createElement(_Icon["default"].CloseOutline, null),
          onClick: this.handleOnClear
        }) : _react["default"].createElement(_Icon["default"].Time, {
          color: "blue"
        })
      }), _react["default"].createElement(_Options["default"], {
        visible: visible,
        hourRef: this.hourRef,
        minuteRef: this.minuteRef,
        onChange: this.handleOnChange,
        onModeChange: this.handleOnModeChange,
        isHourSelected: this.isHourSelected,
        isMinuteSelected: this.isMinuteSelected,
        isAMPMSelected: this.isAMPMSelected,
        hourOptions: use24Hours ? _constants.hour24 : _constants.hour,
        minuteOptions: _constants.minute,
        ampmOptions: !use24Hours ? _constants.ampm : null
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var value = props.value;
      var newValue = getMomentObj(props);
      return {
        // Store the previous props in state
        prevProps: {
          value: value
        },
        value: prevProps.value !== value ? newValue : state.value
      };
    }
  }]);

  return TimePicker;
}(_react.PureComponent);

exports["default"] = TimePicker;

_defineProperty(TimePicker, "className", 'MHub-TimePicker');

_defineProperty(TimePicker, "Options", _Options["default"]);

_defineProperty(TimePicker, "propTypes", {
  value: _common.customPropTypes.moment,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  clearable: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  use24Hours: _propTypes["default"].bool,
  format: _propTypes["default"].string,
  renderFormat: _propTypes["default"].string
});

_defineProperty(TimePicker, "defaultProps", {
  value: null,
  name: null,
  onChange: null,
  onClick: null,
  onOpen: null,
  onClose: null,
  clearable: true,
  readOnly: false,
  disabled: false,
  use24Hours: false,
  format: 'LT',
  renderFormat: 'LT'
});